// Used in side-panel-right, header.component, side-nav.component, teacher.component, student.component

import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class OpenSidePanelRightHelper {
    private messageSource = new BehaviorSubject<string>("");
    currentTab = this.messageSource.asObservable();

    constructor() {}

    changeTab(tab: string) {
        this.messageSource.next(tab);
    }

    close() {
        this.messageSource.next("close");
    }
}
